package net.frozenbit.games.soundgame

import kotlinx.browser.localStorage
import kotlinx.browser.sessionStorage
import org.w3c.dom.Storage
import kotlin.time.Clock
import kotlin.time.Duration

class StorageKeyValueStore(
    private val storage: Storage,
) : KeyValueStore {
    private val clock = Clock.System
    private fun ttlKey(key: String) = "__ttl__:$key"

    override fun get(key: String): String? {
        val expiryMillis = storage.getItem(ttlKey(key))?.toLongOrNull()
        if (expiryMillis != null && clock.now().toEpochMilliseconds() >= expiryMillis) {
            remove(key)
            return null
        }
        return storage.getItem(key)
    }

    override fun set(key: String, value: String, maxLifetime: Duration?) {
        storage.setItem(key, value)
        if (maxLifetime != null) {
            val expiry = clock.now().plus(maxLifetime).toEpochMilliseconds()
            storage.setItem(ttlKey(key), expiry.toString())
        } else {
            storage.removeItem(ttlKey(key))
        }
    }

    override fun remove(key: String) {
        storage.removeItem(key)
        storage.removeItem(ttlKey(key))
    }
}

val LocalStorageKeyValueStore by lazy { StorageKeyValueStore(localStorage) }
val SessionStorageKeyValueStore by lazy { StorageKeyValueStore(sessionStorage) }
